import { useState, useRef, useEffect } from "react";

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
}

function highlightSubstring(substring, fullString) {
    if (!substring) return fullString;
    const parts = fullString.split(new RegExp(`(${escapeRegExp(substring)})`, 'gi')); // Split on the substring, keeping it in the result

    return (
        <span>
            {parts.map((part, index) =>
                part.toLowerCase() === substring.toLowerCase() ? (
                    <b key={index} style={{
                        textShadow: '1px 1px 2px #c7c7c7ff',
                    }}>{part}</b> 
                ) : (
                    part 
                )
            )}
        </span>
    );
}

const EditStatSelectDropdown = ({current, dropdownOptions, setParentInputs, contentPath, actionIndex}) => {
    const [open, setOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(current)
    const [searchValue, setSearchValue] = useState('')
    const dropdownRef = useRef(null);

    const handleOptionClick = (option, selectedOptionIndex) => {
        setSelectedOption(option);
        setParentInputs(option, actionIndex, contentPath, selectedOptionIndex)
    };

    // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="editSelectDropContainer" ref={dropdownRef}>
            <div className="dropdownSvgContainer" style={open ? {backgroundColor: "#dcd9d0", outline: "1px solid #919191"} : {}} onClick={() => setOpen(o => !o)}>
                <svg width="16" height="16" viewBox="0 0 16 16" style={{
                    verticalAlign: "middle",
                    transition: "transform 0.2s",
                    transform: open ? "rotate(0deg)" : "rotate(90deg)",
                    minWidth: "16px",
                    minHeight: "16px"
                }}>
                    <polyline points="4,6 8,10 12,6" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
            
            {open && (
                <div className="editOptionsListContainer" style={{ minWidth: "150px"}}>
                    <input
                        id='encounterSearch'
                        type="text"
                        placeholder="Search..."
                        value={searchValue}
                        onChange={e => setSearchValue(e.target.value)}
                        style={{
                            width: '97%',
                            padding: "4px 0px 5px 2px",
                            margin: '5px 0',
                            border: "2px solid rgb(157, 125, 72)",
                            fontSize: "0.8em",
                        }}
                        autoFocus={true}
                    />
                    <ul className="searchOptionCheckboxList">
                        {dropdownOptions.map((option, i) => (
                            <>
                                {option.toLowerCase().includes(searchValue.toLowerCase()) && 
                                    <label key={option+'label'} style={{ cursor: "pointer" }}>
                                        <li key={option+'li'} className="searchOptionCheckboxListItem" style={{borderBottom: selectedOption === option ? '2px dotted black' : ''}} onClick={() => handleOptionClick(option, i)}>
                                            {highlightSubstring(searchValue, option)} {selectedOption === option ? "✓" : ""}
                                        </li>
                                    </label>
                                }
                            </>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default EditStatSelectDropdown;